import axiosInstance from '../func/axiosInstance';

export const defineEmpresa = async (valor) => {
    return axiosInstance.post('/validarEmpresa', {
        CNPJ: valor
    });
};

export const login = async (credencial) => {
    return axiosInstance.post('/login', {
        CNPJ: credencial.cnpj,
        LOGIN: credencial.login,
        SENHA: credencial.senha
    });
};

export const loginAdmin = async (credencial) => {
    return axiosInstance.post('/admin/login', {
        LOGIN: credencial.login,
        SENHA: credencial.senha
    });
};

